import React, {createRef, ReactElement, RefObject} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {Column} from 'primereact/column';
import MTable, {MTableFilters} from '../../Toolkit/Components/Controls/Table';
import MButton from '../../Toolkit/Components/Controls/Button';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import {MNewIconName} from '../../Toolkit/Icons';
import {GotoIconName, DigStatusNames} from '../SafeDigConstants';
import TaskEditDialog from '../Dialogs/TaskEditDialog';
import {DataTableSortMeta} from 'primereact/datatable';
import {SafeDig} from '../../Api/SafeDigTypes';
import MSpacer from '../../Toolkit/Components/Controls/Spacer';

type SubJobRow = {
    data: SafeDig;
}

type Props = {
    rowData: SubJobRow[];
    navigateTo: (estimate: number, newJob: boolean) => void;
}

/** */
type State = {
    filters: MTableFilters;
    selectedRow?: SubJobRow;
}

class SubJobControl extends MComponent<Props, State> {

    private readonly m_editRef: RefObject<TaskEditDialog>;

    public constructor(props: Props) {
        super(props);

        this.m_editRef = createRef<TaskEditDialog>();

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {
        this.edit_Click = this.edit_Click.bind(this);
        this.new_Click = this.new_Click.bind(this);
        this.isGotoDisabled = this.isGotoDisabled.bind(this);
        this.table_onSelectionChange = this.table_onSelectionChange.bind(this);
    }

    private initializeState(): void {
        this.state = {
            filters: {}
        };
    }

    private isGotoDisabled(): boolean {
        return this.state.selectedRow === undefined;
    }

    private table_onSelectionChange(selection: SubJobRow | SubJobRow[] | undefined): void {

        this.safeSetState((draft: State) =>
            draft.selectedRow = selection as SubJobRow | undefined);

    }

    private edit_Click(): void {
        this.props.navigateTo(this.state.selectedRow!.data!.safeDigsId, false);
    }

    private new_Click(): void {
        this.props.navigateTo(-1, true);
    }

    private statusTemplate(rowData: SubJobRow): string {
        if(rowData.data.hotJob && rowData.data.supervisionDate !== null) {
            if(rowData.data.supervisionDate > new Date() && rowData.data.digStatus === 3) {
                return DigStatusNames[rowData.data.digStatus] + ' - ' + rowData.data.supervisionDate.toLocaleDateString();
            }
        }
        return DigStatusNames[rowData.data.digStatus];
    }

    private tableSortTemplate(): DataTableSortMeta[] {
        return [
            {field: 'data.estimate', order: 1}
        ];
    }

    public render(): ReactElement {
        return (
            <React.Fragment>
                <MToolbar>
                    <MButton label="Add"
                             icon={MNewIconName}
                             color={"success"}
                             disabled={false}
                             onClick={this.new_Click}/>
                    <MSpacer/>
                    <MButton label="Go To"
                             icon={GotoIconName}
                             disabled={this.isGotoDisabled}
                             onClick={this.edit_Click}/>
                </MToolbar>
                <MTable
                    rowKey="data.safeDigsId"
                    rowData={this.props.rowData}
                    filters={this.state.filters}
                    onSelectionChange={this.table_onSelectionChange}
                    sortMode={'multiple'}
                    multiSortMeta={this.tableSortTemplate()}>

                    <Column field="data.estimate"
                            header="ID"
                            filter={false}
                            sortable={true}
                            style={{width: '25%'}}/>
                    <Column field="data.digstatus"
                            body={this.statusTemplate}
                            header="Status"
                            filter={false}
                            sortable={false}
                            style={{width: '75%'}}/>
                </MTable>
            </React.Fragment>
        );
    }
}

export default SubJobControl;